import React from 'react';
import '../styles/UnreadDivider.css';

function UnreadDivider() {
  return (
    <div className="unread-divider">
      <div className="unread-divider-line"></div>
      <span className="unread-divider-text">Новые сообщения</span>
      <div className="unread-divider-line"></div>
    </div>
  );
}

export default UnreadDivider;
